var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEnergyConsumption = function SvgEnergyConsumption(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 311,
    height: 136,
    viewBox: "0 0 311 136",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.302,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65a844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453",
    transform: "translate(-250 -724)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_0",
    "data-name": 0,
    transform: "translate(267 834)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.615,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("text", {
    id: "_25",
    "data-name": 25,
    transform: "translate(267 809)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.23,
    y: 0
  }, "25")), /*#__PURE__*/React.createElement("text", {
    id: "_50",
    "data-name": 50,
    transform: "translate(267 784)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.23,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("text", {
    id: "_100",
    "data-name": 100,
    transform: "translate(267 734)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.846,
    y: 0
  }, "100")), /*#__PURE__*/React.createElement("text", {
    id: "_12",
    "data-name": 12,
    transform: "translate(561 857)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.23,
    y: 0
  }, "12")), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(511 857)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.615,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(467 857)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.615,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    id: "_12-2",
    "data-name": 12,
    transform: "translate(422 857)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.23,
    y: 0
  }, "12")), /*#__PURE__*/React.createElement("text", {
    id: "_8-2",
    "data-name": 8,
    transform: "translate(372 857)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.615,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("text", {
    id: "_4-2",
    "data-name": 4,
    transform: "translate(328 857)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.615,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    id: "_75",
    "data-name": 75,
    transform: "translate(267 759)",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.23,
    y: 0
  }, "75")), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M250,730.629s2.435-5.927,8.074-6.158,6.64,10.061,10.509,10.451,5.191-4.451,8.162-4.293,4.661,1.59,6.308,5.974,2.966,10.443,7.347,10.339,2.31-6.607,7.485-6.872,4.852,11.484,9.554,11.523,6.066-7.305,6.582-11.523,3.07-9.327,7.462-9.441,8.647,5.536,9.324,13.2,4.816,10.886,10.23,10.5,6.432-7.651,11.135-10.5,6.967-4.2,14.011,0,8.441,24.1,17.221,24.356,12.96-4.046,15.757-12.425,5.508-21.426,11.252-20.84,4.576,19.311,10.932,19.412,8.946-19.7,18.18-19.412,8,30.065,19.888,29.6,14.479-10.336,23.393-10.191,16.16,14.208,22.713,13.853,13.019-13.7,16.522-19.81S534,739.33,534,739.33V818.7l-284,.74Z",
    transform: "translate(27 17.533)",
    fill: "url(#linear-gradient)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEnergyConsumption);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/energy_consumption.92af2eb1e2a9ef44ff27b97d3aea707a.svg";